import { memo } from 'react'
import { ButtonBase } from '@mui/material'
import { Box } from '@/components/Layout'
import { Text } from '@/components/Data'
import { useTranslations } from '@/core/translation'
import HistoryItem from './HistoryItem'
import { sidebarHistoryStyles as styles } from './SidebarHistory.style'
import { SidebarHistoryProps } from './SidebarHistory.types'

function SidebarHistory({ items, activeId, onOpen, onRemove, onClear }: SidebarHistoryProps) {
  const t = useTranslations('sidebar')

  return (
    <Box sx={styles.root}>
      <Box sx={styles.header}>
        <Text sx={styles.headerLabel}>{t('recents')}</Text>
        {items.length > 0 && (
          <ButtonBase sx={styles.clear} onClick={onClear}>
            <Text component="span" sx={styles.clearLabel}>
              {t('clearAll')}
            </Text>
          </ButtonBase>
        )}
      </Box>

      {items.length === 0 ? (
        <Text sx={styles.empty}>{t('recentsEmpty')}</Text>
      ) : (
        <Box sx={styles.list}>
          {items.map((item) => (
            <HistoryItem
              key={item.id}
              item={item}
              isActive={item.id === activeId}
              onOpen={onOpen}
              onRemove={onRemove}
            />
          ))}
        </Box>
      )}
    </Box>
  )
}

export default memo(SidebarHistory)
